import { createAction, props } from "@ngrx/store";
import ISkillType from "@skills-app/models/skillType";

const prefix = "[Skill Types API]";

export const populateSkillTypes = createAction(
  `${prefix} Populate Skill Types`,
  props<{ skillTypes: ISkillType[] }>(),
);
export const skillTypeAdded = createAction(`${prefix} Skill Type Added`);
export const addSkillTypeError = createAction(`${prefix} Add Skill Type Error`);
export const skillTypeEdited = createAction(`${prefix} Skill Type Edited`);
export const editSkillTypeError = createAction(
  `${prefix} Edit Skill Type Error`,
);
export const skillTypeDeleted = createAction(`${prefix} Skill Type Deleted`);
